export default __webpack_public_path__ + "static/media/sellingPointTwo.e836b36b.jpg";